import { render, staticRenderFns } from "./ver_pub.vue?vue&type=template&id=074f90a0&scoped=true&"
import script from "./ver_pub.vue?vue&type=script&lang=js&"
export * from "./ver_pub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074f90a0",
  null
  
)

export default component.exports